/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useEffect } from 'react';
import { View, TouchableOpacity, ScrollView } from 'react-native';

import Colors from '@global/colors';
import { isWeb, isWebPlatform } from '@global/screens';

import * as Layout from '@components/screen/Layout';
import Image from '@components/global/Image';
import Photo from '@components/global/Photo';
import SociollaText from '@components/sociolla/SociollaText';
import SearchTable from '@components/table/SearchTable';

const defaultPhoto = require('@/assets/img/default/image-default.png');

const SelectFormRules = ({
  type = 'customer', // type of search
  withoutResult = false, // dont show the result
  value, // value of specific type
  placeholder = 'Search something...',
  onChange, // on change callback
  showList = {}, // show list based on type
  searchKeyword = {}, // search keyword based on type
  isLoading = {}, // loading based on type
  isLoadingMore = {}, // loading pagination based on type
  isEmpty = {}, // set empty value based on type
  lists = [], // list data based on type
  selectedBox,
  setShowList = () => {},
  setSelectedBox = () => {},
  onSearch = () => {},
  onLoadMore = () => {},
  noMounted = false,
}) => {
  useEffect(() => {
    if (!noMounted) {
      let mounted = true;
      if (mounted && value?.length) {
        setSelectedBox(value);
      }
      return () => {
        mounted = false;
      };
    }
  }, []);

  // handling selected value
  const onSelectItem = (item) => {
    const convertPr = (pr) => {
      return {
        id: pr.id,
        name: pr.name,
        brand: {
          id: pr.brand?.id,
          name: pr.brand?.name,
        },
        combination_id: pr.combination_id,
        variant: pr.variant,
        sku: pr.sku,
        image: pr.image,
        quantity: 1,
      };
    };
    try {
      if (withoutResult) {
        item = convertPr(item);
        onChange(item);
      } else {
        const result = JSON.parse(JSON.stringify(selectedBox));
        if (type == 'product') {
          item = convertPr(item);
        }
        const finalData = result.concat(item);
        setSelectedBox(finalData);
        onChange(finalData);
      }
      setShowList({ ...showList, [type]: false });
    } catch (error) {}
  };

  // remove selected value
  const onRemoveItem = (index) => {
    try {
      const result = JSON.parse(JSON.stringify(selectedBox));
      result.splice(index, 1);
      setSelectedBox(result);
      onChange(result);
    } catch (error) {}
  };

  return (
    <View style={{ width: '80%', marginBottom: 15 }}>
      <View style={{ width: '100%' }}>
        <SearchTable
          value={searchKeyword[type]}
          width={'100%'}
          onSearch={(val) => {
            onSearch({ type: type, value: val });
          }}
          withBorder={true}
          searchPlaceholder={placeholder}
        />
        {/* Start List Container */}
        {showList[type] ? (
          <>
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => setShowList({ ...showList, [type]: false })}
              style={{
                position: isWebPlatform ? 'fixed' : 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                zIndex: 99,
                elevation: 99,
                cursor: 'auto',
              }}></TouchableOpacity>
            <ScrollView
              id="search-lists"
              style={{
                width: '100%',
                maxHeight: 300,
                borderColor: Colors.grey0,
                borderWidth: 1,
                zIndex: 100,
                elevation: 100,
              }}>
              {isLoading[type] ? (
                <Layout.Loader />
              ) : lists?.length ? (
                lists.map((item, idx) => (
                  <TouchableOpacity
                    onPress={() => onSelectItem(item)}
                    activeOpacity={0.6}
                    style={{
                      width: '100%',
                      maxHeight: 300,
                      padding: 15,
                      flexDirection: 'row',
                      alignItems: 'center',
                      borderBottomWidth: 1,
                      borderBottomColor: Colors.grey0,
                    }}
                    key={idx}>
                    {['product', 'free_product'].includes(type) ? (
                      <>
                        <View
                          style={{
                            width: '20%',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}>
                          <Image
                            source={`${item.image ? item.image : defaultPhoto}`}
                            style={{ width: 36, height: 36 }}
                            width={36}
                            height={36}
                          />
                        </View>
                        <View style={{ width: '80%' }}>
                          <SociollaText type="medium" style={{ fontSize: 13 }}>
                            {item?.brand?.name ? `${item.brand.name} - ` : ''}
                            {item.name}
                          </SociollaText>
                          <SociollaText
                            style={{ fontSize: 12, color: Colors.grey1 }}>
                            [{item.sku ? item.sku : '-'}]
                          </SociollaText>
                        </View>
                      </>
                    ) : (
                      <>
                        {type == 'customer' ? (
                          <Photo width={25} height={25} image={item.image} />
                        ) : (
                          false
                        )}
                        <SociollaText type="medium" style={{ fontSize: 13 }}>
                          {item.name}
                        </SociollaText>
                      </>
                    )}
                  </TouchableOpacity>
                ))
              ) : (
                <View
                  style={{
                    width: '100%',
                    padding: 20,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <SociollaText>No data</SociollaText>
                </View>
              )}
              {/* Start Loader */}
              {isLoadingMore[type] ? <Layout.Loader /> : false}
              {/* End Loader */}
              {/* Start Load More Button */}
              {!isEmpty[type] &&
              !isLoadingMore[type] &&
              !isLoading[type] &&
              lists?.length >= 10 ? (
                <TouchableOpacity
                  activeOpacity={0.7}
                  style={{
                    width: '100%',
                    padding: 15,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderTopWidth: 1,
                    borderTopColor: Colors.grey0,
                  }}
                  onPress={() => {
                    onLoadMore(type);
                  }}>
                  <SociollaText>Load More</SociollaText>
                </TouchableOpacity>
              ) : (
                false
              )}
              {/* End Load More Button */}
            </ScrollView>
          </>
        ) : (
          false
        )}
      </View>
      {/* End List Container */}
      {/* Start Result Container */}
      {!withoutResult && selectedBox?.length && !noMounted ? (
        <ScrollView
          contentContainerStyle={{ width: '100%', maxHeight: 250 }}
          showsVerticalScrollIndicator={isWeb}>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              marginTop: 15,
            }}>
            {(selectedBox || []).map((item, idx) => (
              <TouchableOpacity
                activeOpacity={0.8}
                style={{
                  backgroundColor: Colors.blue6,
                  paddingHorizontal: 12,
                  paddingVertical: 7,
                  marginLeft: 5,
                  borderRadius: 12,
                  marginVertical: 5,
                  minHeight: 19,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  maxWidth: '97%',
                }}
                key={idx}>
                <SociollaText style={{ fontSize: 11, marginRight: 15 }}>
                  {['product', 'free_product'].includes(type)
                    ? `${item?.brand?.name ? `${item.brand.name} - ` : ''}`
                    : ''}
                  {item.name}
                </SociollaText>
                <TouchableOpacity onPress={() => onRemoveItem(idx)}>
                  <Image
                    width={8}
                    height={8}
                    style={{ width: 8, height: 8 }}
                    svg={true}
                    source={require('@assets/img/icons/close-grey.svg')}
                  />
                </TouchableOpacity>
              </TouchableOpacity>
            ))}
          </View>
        </ScrollView>
      ) : (
        false
      )}
      {/* End Result Container */}
    </View>
  );
};

export default SelectFormRules;
